var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(true),expression:"true",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"element-loading-text":"钉钉登录中"}})}
var staticRenderFns = []

export { render, staticRenderFns }